<router-outlet />
<div class="notification-overlay" aria-live="polite" aria-atomic="true">
    @for (note of _uiController.notifications; track note) {
        <ngb-toast 
            [class]="note.cssClass"
            [header]="note.header || ''" 
            [delay]="note.delay || 5000"
            (hidden)="_uiController.removeNote(note)"
            >
            @if (note.template) {
                <ng-template [ngTemplateOutlet]="note.template"></ng-template>
            } @else {
                {{note.body}}
            }
        </ngb-toast>
    }
</div>
  